// Pieza 4: lo que dice el Tesoro (diseño 4a, §2.6). Ordena `sancionados[ref]` para la ficha: el porqué, qué significa, la historia,
// la cita con su traducción, los organigramas y las fuentes por índice. Sin marca de revisión (decisión 6 de Bernardo): basta
// «Según el Tesoro,» (ya en el texto), la cita exacta y «Ver la fuente». No dibuja: los organigramas se abren como fuente.
import type { Fuente, Hallazgos } from '../hallazgos/tipos.ts';
import { abrible, contextoDe, type FuenteAbrible } from './fuente.ts';
import { ROTULOS, rotulo } from './rotulos.ts';

export interface BloqueTesoro {
  ref: string;
  /** «Por qué OFAC sancionó a [nombre]» (23). */
  titulo: string;
  porque: string;
  /** «Qué significa la sanción:» (24) y la frase del documento. */
  significa: { rotulo: string; texto: string };
  historia: { texto: string; voz: 'tesoro' | 'lista_ofac' | 'argus'; fuente: number | null; fuenteRelacion: number | null }[];
  /** La cita del comunicado con la traducción de Argus (25) y «Leer el original en inglés» (27). */
  cita: { original: string; traduccion: string; voz: string; leerOriginal: string; fuente: number } | null;
  organigramas: number[];
  /** Fuentes por índice, con lo que se puede abrir de cada una (llave cuando la hay). */
  fuentes: { fuente: Fuente; abrible: FuenteAbrible }[];
}

/** Lo que dice el Tesoro de un sancionado de la ficha; null si no está en `sancionados`. */
export function loQueDiceElTesoro(doc: Hallazgos, ref: string): BloqueTesoro | null {
  const s = doc.sancionados[ref];
  if (!s) return null;
  const ctx = contextoDe(doc, ref);
  const fuentes: BloqueTesoro['fuentes'] = [];
  const indice = new Map<string, number>();
  const idx = (f: Fuente | null | undefined): number | null => {
    if (!f) return null;
    const k = JSON.stringify(f);
    if (!indice.has(k)) {
      indice.set(k, fuentes.length);
      fuentes.push({ fuente: f, abrible: abrible(f, ctx) });
    }
    return indice.get(k)!;
  };
  const p = s.por_que;
  return {
    ref,
    titulo: rotulo(ROTULOS.porQue, { nombre: s.nombre }),
    porque: p.texto,
    significa: { rotulo: ROTULOS.significa, texto: p.significa },
    historia: p.historia.map((x) => ({ texto: x.texto, voz: x.voz, fuente: idx(x.fuente), fuenteRelacion: idx(x.fuente_relacion) })),
    cita: p.cita ? { original: p.cita.original, traduccion: p.cita.traduccion, voz: p.cita.voz, leerOriginal: ROTULOS.leerOriginal, fuente: idx(p.cita.fuente)! } : null,
    organigramas: p.organigramas.map((o) => idx(o)!),
    fuentes,
  };
}
